import { Flex, IconButton, Tooltip } from "@chakra-ui/react";
import axios from "axios";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaFolderPlus } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { createNewFolder } from "../../../_actions/folderActions";
import TldrSearch from "../../common/TldrSearch";
import { TldrNewFolderDialog } from "./statelessView";

const TldrTitleSearchRow = (props) => {
  const signal = axios.CancelToken.source();

  const {
    searchBoxWidth,
    disableSearch,
    searchPlaceholder,
    showNewFolderButton,
    showFilterOptions,
    handleSearch,
    handleEnterKeyEvent,
    onClear,
  } = props;
  const { t } = useTranslation(["folders"]);

  const [showNewFolderModal, setShowNewFolderModal] = useState(false);
  const [inProgress, setInProgress] = useState(false);

  const dispatch = useDispatch();

  function handleCreateNewFolder(name) {
    setInProgress(true);

    dispatch(
      createNewFolder(name, signal.token, {
        ...props,
      })
    )
      .then((folder) => {
        setInProgress(false);
        setShowNewFolderModal(false);
      })
      .catch(() => {
        setInProgress(false);
        setShowNewFolderModal(false);
      });
  }

  function handleOnSearch(searchKey) {
    handleSearch(searchKey);
  }

  return (
    <>
      <Flex direction="row" align="center">
        {!disableSearch ? (
          <TldrSearch
            width={searchBoxWidth || "300px"}
            placeholder={searchPlaceholder}
            onSearch={(keyword) => {
              handleOnSearch(keyword);
            }}
            onClear={onClear}
            handleEnterKeyEvent={handleEnterKeyEvent}
            searchLocation="dashboard"
          />
        ) : null}

        {showFilterOptions ? <>{props.children}</> : null}

        {showNewFolderButton ? (
          <Tooltip label={t("new_folder_button.text")} hasArrow>
            <IconButton
              icon={<FaFolderPlus />}
              onClick={() => setShowNewFolderModal(true)}
              ml="0.75rem"
              variant="ghost"
              size="md"
              color="gray.100"
            />
          </Tooltip>
        ) : null}
      </Flex>

      {showNewFolderModal ? (
        <TldrNewFolderDialog
          inProgress={inProgress}
          show={showNewFolderModal}
          onHide={() => {
            setShowNewFolderModal(false);
          }}
          onYes={(name) => {
            handleCreateNewFolder(name);
          }}
        />
      ) : null}
    </>
  );
};

export default TldrTitleSearchRow;
